import { useTranslation } from "react-i18next";

import { DayMenuItem } from "../..";

interface DayMenuProps {
  setAddModal: React.Dispatch<React.SetStateAction<boolean>>;
  setAddOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setCopyShiftsDayModal: React.Dispatch<React.SetStateAction<boolean>>;
  setClearDayShiftsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function DayMenu({
  setAddModal,
  setAddOpenModal,
  setCopyShiftsDayModal,
  setClearDayShiftsModal,
}: DayMenuProps) {
  const { t } = useTranslation();
  return (
    <div className="border-[1px]  absolute bg-white z-50 border-[#F1F1F4]  rounded-xl p-2.5">
      <DayMenuItem
        onClick={() => setAddModal(true)}
        icon="add-notepad"
        color="#296573"
        title={t("shift.Add New Shift")}
      />
      <DayMenuItem
        onClick={() => {
          setAddOpenModal(true);
        }}
        icon="add-files"
        color="#DFA000"
        title={t("shift.Add New Open Shift")}
      />
      <DayMenuItem
        icon="copy-success"
        color="#056EE9"
        title={t("shift.Copy This Day")}
        onClick={() => setCopyShiftsDayModal(true)}
      />
      <DayMenuItem
        onClick={() => setClearDayShiftsModal(true)}
        icon="trash-square"
        color="red"
        title={t("shift.Clear This Day")}
      />
    </div>
  );
}
